import * as React from 'react';
import { withRouteData } from 'react-static';

import HomePageComponent from '../../components/HomePage/HomePage';

import { HomePageLocale } from '../../components/HomePage/homePage.locale';

interface HomePageProps {
  locale: HomePageLocale;
}

const HomePage: React.SFC<HomePageProps> = ({ locale }) => <HomePageComponent locale={locale} />;

export default withRouteData(HomePage);



// WEBPACK FOOTER //
// /www/client/src/containers/HomePage/HomePage.tsx